export default "__VITE_PUBLIC_ASSET__7c762aec__"